import { render } from "./EmailSend.vue?vue&type=template&id=24f79d2c"
import script from "./EmailSend.vue?vue&type=script&lang=js"
export * from "./EmailSend.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__